import React from 'react';
import { Grid, Typography, Box, List, ListItem, ListItemText, ListItemIcon, Paper, Button } from '@mui/material';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';


export default function SuperChargeOrder({ isMobile, language, translations, scrollToSection,
    contactusRef }: {
        isMobile: boolean, language: any, translations: any, scrollToSection: any,
        contactusRef: any
    }) {
    const dictionary = getDictionary(translations, 'supercharge', language);
    const isArabic = language === 'arabic';
    return (<>

        <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"}  >
            {!isMobile && (<>
                <Grid item xs={12} md={6}>
                    <Box display="flex" justifyContent="center">
                        <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/supercharge1.webp`} loading="lazy" width={"100%"} height={"100%"} alt='supercharge' />
                    </Box>
                </Grid>
            </>)}

            <Grid item xs={12} md={6}>
                <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                    <div >
                        <div style={{ position: 'relative', zIndex: 0 }}>
                            <Typography paragraph fontWeight="bold" fontSize={"20px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                {getField(dictionary, 'title', language)}
                            </Typography>
                        </div>
                        <div style={{ position: 'relative', zIndex: -1 }}>
                            {getSvg('doubleLinesIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: isArabic ? "15%" : "20%", height: 'auto' }, { position: 'absolute', transform: isArabic ? "translate(-10rem , -1rem)" : "translate(12rem , -1rem)" })}
                        </div>
                    </div>
                    <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText
                                primary={
                                    <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                        <span style={{ color: 'var(--accent-secondary)' }}>&#10004; </span>
                                        {getField(dictionary, 'list-title-one', language)}
                                    </span>
                                }
                                secondary={
                                    <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' :"1px", fontSize: "17px" }}>
                                        {getField(dictionary, 'list-item-one', language)}
                                    </span>
                                }
                            />
                        </ListItem>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText
                                primary={
                                    <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                        <span style={{ color: 'var(--accent-secondary)' }}>&#10004; </span>
                                        {getField(dictionary, 'list-title-two', language)}
                                    </span>
                                }
                                secondary={
                                    <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' :"1px", fontSize: "17px" }}>
                                        {getField(dictionary, 'list-item-two', language)}
                                    </span>
                                }
                            />
                        </ListItem>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText
                                primary={
                                    <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                        <span style={{ color: 'var(--accent-secondary)' }}>&#10004;</span>
                                        {getField(dictionary, 'list-title-three', language)}
                                    </span>
                                }
                                secondary={
                                    <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                        {getField(dictionary, 'list-item-three', language)}
                                    </span>
                                }
                            />
                        </ListItem>
                    </List>
                    <Button
                        variant='contained'
                        sx={{
                            backgroundColor: "var(--accent-primary)",
                            color: "white",
                            marginTop: "10px",
                            transition: 'background-color 0.3s ease',
                            '&:hover': {
                                backgroundColor: "var(--accent-primary)",
                            },
                        }}
                    >
                        <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                            {getField(dictionary, 'start-increasing-orders', language)}
                        </a>

                    </Button>
                </Paper>
            </Grid>
            {isMobile && (<>
                <Grid item xs={12} md={6} justifyContent={'center'}>
                    <Box display="flex" justifyContent="center">
                        <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/supercharge1.webp`} loading="lazy" width={"100%"} height={"100%"} alt='supercharge' />
                    </Box>
                </Grid>
            </>)}

        </Grid>
    </>)
}